import { Link } from "react-router-dom";
import SeoHead from "@/components/SeoHead";
import { Button } from "@/components/ui/button";
import { Home, Search, Phone } from "lucide-react";

export default function NotFound() {
  return (
    <>
      <SeoHead
        title="Page not found (404)"
        description="The page you're looking for doesn't exist. Explore commercial mortgages, development funding, bridging & private mortgages at OzyLoans."
        path="/404"
        noindex={true}
      />
      <section
        data-testid="not-found-page"
        aria-labelledby="not-found-heading"
        className="min-h-[calc(100vh-160px)] flex items-center justify-center px-6 py-24 bg-black text-white"
      >
        <div className="max-w-xl w-full text-center">
          <div
            aria-hidden="true"
            className="font-bebas text-[140px] sm:text-[180px] leading-none tracking-wide text-[#E50914]"
            style={{ textShadow: "0 0 60px rgba(229,9,20,0.35)" }}
          >
            404
          </div>
          <h1 className="mt-4 font-bebas text-4xl sm:text-5xl tracking-wide text-white">
            Page not found
          </h1>
          <p className="mt-4 text-base sm:text-lg text-zinc-400 leading-relaxed">
            The page you&apos;re looking for has moved or doesn&apos;t exist. Let&apos;s get you back to something useful.
          </p>
          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Button
              asChild
              data-testid="not-found-home-button"
              className="bg-[#E50914] hover:bg-[#F6121D] text-white font-semibold rounded-full px-6 h-11"
            >
              <Link to="/">
                <Home className="w-4 h-4 mr-2" /> Return home
              </Link>
            </Button>
            <Button
              asChild
              variant="outline"
              data-testid="not-found-insights-button"
              className="border-zinc-700 text-white hover:bg-zinc-900 rounded-full px-6 h-11"
            >
              <Link to="/insights">
                <Search className="w-4 h-4 mr-2" /> Read our insights
              </Link>
            </Button>
            <Button
              asChild
              variant="ghost"
              data-testid="not-found-call-button"
              className="text-zinc-300 hover:text-white hover:bg-zinc-900 rounded-full px-6 h-11"
            >
              <a href="tel:+61426976876">
                <Phone className="w-4 h-4 mr-2" /> Call an advisor
              </a>
            </Button>
          </div>
          <div className="mt-14 pt-8 border-t border-zinc-900 text-xs text-zinc-600">
            OzyLoans · ACL #485752 · AFCA #618333 · MFAA #246073
          </div>
        </div>
      </section>
    </>
  );
}
